/**
 * URL Helpers - Environment-aware URL generation
 */

/**
 * Get the frontend base URL based on environment
 * Development: http://localhost:3027
 * Production: https://bhriguhora.com
 */
export function getFrontendBaseUrl(): string {
  // Check if REACT_APP_FRONTEND_URL is set
  if (process.env.REACT_APP_FRONTEND_URL) {
    return process.env.REACT_APP_FRONTEND_URL;
  }

  // Fallback: auto-detect from window.location
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;

    // If running on localhost, include port
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${protocol}//${hostname}:${port}`;
    }

    // Production: use hostname without port
    return `${protocol}//${hostname}`;
  }

  // SSR fallback
  return 'https://bhriguhora.com';
}

/**
 * Build full short link URL
 * @param shortCode - The short code (e.g., "HOTF0uXi")
 * @returns Full URL (e.g., "http://localhost:3027/s/HOTF0uXi" or "https://bhriguhora.com/s/HOTF0uXi")
 */
export function buildShortLinkUrl(shortCode: string): string {
  const baseUrl = getFrontendBaseUrl();
  return `${baseUrl}/s/${shortCode}`;
}
